<template>
  <v-text-field
    ref="myInput"
    style="margin-top: 2px;margin-bottom: 2px;"
    outlined
    hide-details
    dense
    :disabled="disabled"
    :placeholder="placeholder"
    autocomplete="new-password"
    :readonly="!editable"
    :style="{width: width}"
    :rules="mdpRules"
    :value="value"
    :type="showPassword ? 'text' : 'password'"
    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
    @input="$emit('input',$event)"
    @click:append="showPassword = !showPassword"
  />
<!--        <input  class="fx-input fx-input-normal"
           type="text"
           :disabled="disabled"
           :placeholder="placeholder"
           :readonly="!editable"
           :value="value"
           ref="myInput"
           @input="onChange">-->
</template>
<style lang="scss" scoped>

    .fx-input {
        padding-left: 10px ;
        margin-top: 1px;
        margin-bottom: 1px;
        // background-color: white;
        border: 1px solid grey;
        border-radius: 5px;

        // width: 100%;
    }

    .fx-input:focus {
        outline: none !important;
        border: 2px solid #0d6aad;
        // box-shadow: 0 0 10px #719ECE;
    }

    .fx-input-normal {
        height: 40px;
    }

    .fx-input-small {
        height: 30px;
    }
</style>
<script>
export default{
    name: 'FxPasswordInput',
    props: {
        disabled: {
            default: false,
            type: Boolean,
        },
        value: { default: null },
        width: { default: '100%' },
        placeholder: { default: '' },
        editable: {
            default: true,
            type: Boolean,
        },
        rules: {
            type: Array,
            default () {
                return []
            },
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            errorString: '',
            mdpRules: [
                v => !! v || 'Mot de passe requis',
                v => v.length >= 8 || 'Minimun 8 characters',
                v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/.test(v) || 'Le mot de passe doit contenir au moins une majuscule, un chiffre , une minuscule et un caractère spécial',
            ],
            showPassword: false,
        }
    },
    methods: {
        validate () {
            // console.log('rules : ','text-input',this.rules)
            /*this.errorString = '';
                for (const regle of this.rules) {
                    console.log(regle,regle.required , this.value , !this.value.length > 0)
                    switch (regle.type) {
                        case 'required':
                            if (regle.required && !this.value.length > 0) {
                                this.errorString = regle.message
                                return false
                            }
                            break;
                    }
                }
                return true;*/
            return this.$refs.myInput.validate()
        },
        getError () {
            // return this.errorString;
            return this.$refs.myInput.errorBucket[0]
        },
        onChange (event) {
            this.$emit('input', event.target.value)
        },
    },
}
</script>